/**
 * PA classification + scope / setting state. In-memory only.
 */
class ClassificationStore {
  #listeners = new Set();

  #pa1Subs = ["diagnostic"];
  #pa2Subs = [];
  #orExpanded = false;
  #scopes = ["Diagnostic Treatment"];
  #settings = [];

  get pa1Subs() { return this.#pa1Subs; }
  set pa1Subs(v) { this.#pa1Subs = v; this.#notify(); }

  get pa2Subs() { return this.#pa2Subs; }
  set pa2Subs(v) { this.#pa2Subs = v; this.#notify(); }

  get orExpanded() { return this.#orExpanded; }
  set orExpanded(v) { this.#orExpanded = !!v; this.#notify(); }

  get scopes() { return this.#scopes; }
  set scopes(v) { this.#scopes = v; this.#notify(); }

  get settings() { return this.#settings; }
  set settings(v) { this.#settings = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#pa1Subs = ["diagnostic"];
    this.#pa2Subs = [];
    this.#orExpanded = false;
    this.#scopes = ["Diagnostic Treatment"];
    this.#settings = [];
    this.#notify();
  }
}

const classificationStore = new ClassificationStore();
export default classificationStore;
